__webpack_require__.p = "https://smartflow2.coor.com/";